<template>
    <div>
        <el-dialog v-model="confirmShow" title="Tips" width="500" :show-close="false" :align-center="true" :close-on-click-modal="false">
            <template #header>
                <div class="header">提示</div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <div class="content">
                    {{ this.confirmText }}
                </div>
                <div class="confirm_btn_box mar_top_30 flex Flexjustify Flexalign">
                    <div class="btn_cancel cursor_pointer" @click="closePopup">取消</div>
                    <div class="btn_cancel btn_confirm mar_left_20 cursor_pointer" @click="signIn">确认</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5Confirm",
    props: {
        confirmText: {}
    },

    data() {
        return {
            confirmShow: false,
        };
    },

    mounted() { },

    methods: {
        closePopup(){
            this.confirmShow = false;
        },
        signIn(){
            this.$emit('signIn',1);
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 486px;
    height: 240px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

.dialog_content {
    .content {
        width: 100%;
        font-size: 18px;
        color: #111111;
        padding: 20px;
        box-sizing: border-box;
        line-height: 36px;
    }

    .confirm_btn_box {
        .btn_cancel {
            width: 104px;
            height: 36px;
            // background: #E2E2E2;
            border-radius: 18px;
            line-height: 36px;
            text-align: center;
            font-size: 18px;
            color: #13D6AA;
            border: 1px solid #13D6AA;
        }
        .btn_confirm{
            border: none;
            color: #fff;
            background: linear-gradient(90deg, #00DEC9, #00DCA1);
        }
    }
}
</style>